import DateRangePicker, {DateRange} from "@material-ui/lab/DateRangePicker";
import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {Field} from "../../../../components/ContainerFields";
import DateRangeField from "../../../../components/DateRangeField";
import {actionDatesChange} from "../../../../store/statisticSourceOrders/actions";
import {useStatusGroup} from "../../StatusGroupProvider";
import {FieldDatesFC} from "./types";
import moment from "moment/moment";

const FieldDates: FieldDatesFC = ({loading}) => {
    const {statusGroup} = useStatusGroup();
    const {fromDate, toDate} = useSelector(
        ({
             statisticSourceOrders: {
                 [statusGroup]: {fromDate, toDate},
             },
         }) => ({fromDate, toDate})
    );
    const dispatch = useDispatch();
    const [firstLoad, setFirstLoad] = useState(true);
    const [withChange, setChange] = useState(false);
    const [invalidFormatFromDate, setInvalidFormatFromDate] = useState(false);
    const [invalidFormatToDate, setInvalidFormatToDate] = useState(false);
    const handlerChange = ([fromDat, toDat]: DateRange<Date>) => {
        if (!fromDat || !toDat) {
            return;
        }
        const formattedFromDate = moment(fromDat).format('DD.MM.YYYY');
        const formattedToDate = moment(toDat).format('DD.MM.YYYY');
        const isInvalidFormatFromDate = formattedFromDate === 'Invalid date' || moment(formattedFromDate, 'DD.MM.YYYY').isAfter(moment());
        const isInvalidFormatToDate = formattedToDate === 'Invalid date' || moment(formattedToDate, 'DD.MM.YYYY').isAfter(moment());

        setInvalidFormatFromDate(isInvalidFormatFromDate);
        setInvalidFormatToDate(isInvalidFormatToDate);

        dispatch(
            actionDatesChange({
                statusGroup,
                fromDate: fromDat,
                toDate: toDat,
            })
        );
        setChange(true);
    };
    const handlerApply = () => {
        setChange(false);
    };

    useEffect(() => {
        if (firstLoad === true) {
            setFirstLoad(false);
            return;
        }
        if (withChange === true) {
            return;
        }
        if (!invalidFormatFromDate && !invalidFormatToDate) {
            loading();
        }
    }, [withChange, invalidFormatToDate, invalidFormatFromDate]);

    return (
        <Field GridProps={{xs: 12, sm: 4}}>
            <DateRangeField
                fromDate={fromDate}
                toDate={toDate}
                onChange={handlerChange}
                onAccept={handlerApply}
            />
        </Field>
    );
};

export default FieldDates;
